import React from "react";

import styles from "./icons.module.less";

const SVG = ({ className = "", ...props }) => (
  <svg
    className={`${styles.customSvgIcon} ${className}`}
    id="Layer_1"
    version="1.1"
    viewBox="0 0 136.089 136.089"
    x="136.089px"
    xmlns="http://www.w3.org/2000/svg"
    y="136.089px"
    {...props}
  >
    <g>
      <path
        d="M459.271,325.9l0,0v0l-32.075,32.076h64.154v64.153l32.075-32.076h0V325.9Z"
        fill="#f66013"
        transform="translate(-3.582 -532.516) rotate(45)"
      />
    </g>
  </svg>
);

export default SVG;
